import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';

declare var $: any;
@Component({
  selector: 'app-document-client',
  templateUrl: './document-client.component.html',
  styleUrls: ['./document-client.component.css']
})
export class DocumentClientComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  factauto = {};
  avoirAuto = {};
  selected = [];
  dataArticle = [];
  listChantier = [];
  listeAgence = [];
  listeSite = [];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  condition1: Boolean = false;
  condition2: Boolean = false;
  condition3: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  focusIndex = 0;
  listDocument = [];
  deleteElm = [];
  error = '';
  typeDocuments = [];
  dataModif = [];
  disableBtn: Boolean = false;
  loadingIndicator: Boolean = false;

  @ViewChild('msg') msg;
  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.getListDoc().then(data => {
      this.isEmpty = false;
      this.getTypeDoc();
    });
  }


  hide() {
    this.show.emit();
  }

  valide() {
    this.disableBtn = true;
    this.loadingIndicator = true;
    this.saveDoc();
  }

  getTypeDoc() {
    const param = {
      'servlet': 'DBGestionTypeDocSociete',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      this.typeDocuments = datas.data;
    });
  }

  getNameFile(event, item) {
    const file = event.target.files[0];
    
    if(!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);    
      return;
    }            
    
    item.nomFichier = file.name;
    const fileReader = new FileReader();
    const ctrl = this;
    fileReader.onload = function () {
      item.urlImg = fileReader.result;
      const base64 = (<string>fileReader.result).split(',');

      item.contentBase64 = base64[1];
    };
    fileReader.readAsDataURL(file);
  }

  getListDoc() {
    const param = {
      'servlet': 'DBGestionDocClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.listDocument = datas.data;
    });
  }

  openDoc(row) {
    row['clefObjetParent'] = this.detail ? this.detail['id'] : 0;
    row.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 5
        },
        'DOCUMENT': row
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.common.openFile(datas.data[0]);
    });
  }

  onActivate(event) {
    if (event.type === 'dblclick') {
      if (event.row.id !== 0) {
        if (event.row.urlImg) {
          this.common.openBase64(event.row.urlImg, event.row.nomFichier);
        } else {
          this.openDoc(event.row);
        }
      } else {
        this.common.openBase64(event.row.urlImg, event.row.nomFichier);
      }
    }
  }

  saveDoc() {
    const prom = [];
    if (this.deleteElm.length) {
      this.deleteElm.forEach(elt => {
        const fct = this.deleteDoc(elt);
        prom.push(fct);
      });
    }
    const add = this.listDocument.filter(elt => !elt.id);
    if (add.length) {
      add.forEach(elt => {
        elt.id = 0;
        delete elt.urlImg;
        if(elt['nomFichier']) {   
            const fct = this.addDoc(elt);
            prom.push(fct);
        }
      });
    }

    const edit = this.dataModif.filter(elt => elt.isEdit);
    console.log(edit)
    if (edit.length) {
      edit.forEach(elt => {
        elt.id = elt.id || 0;
        delete elt.urlImg;
        delete elt.isEdit;
        delete elt.descriptionLast;
        delete elt.contentBase64Last;
        delete elt.oTypeDocClientLast;
        delete elt.nomFichierLast;
        if(elt['nomFichier']) {           
            const fct = this.addDoc(elt);
            prom.push(fct);
        }
      });
    }

    Promise.all(prom).then(data => {
      this.disableBtn = false;
      this.loadingIndicator = false;
      if (data.length) {
        this.error = 'Enregistrement terminé';
        this.common.openModal(this.modalService, this.msg);
        this.hide();
      }

    }).catch(error => {
      this.disableBtn = false;
      this.common.closeModal();
      console.log(error);
    });
  }

  addDoc(doc) {
    doc['clefObjetParent'] = this.detail ? this.detail['id'] : 0;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  deleteDoc(doc) {
    doc['clefObjetParent'] = this.detail ? this.detail['id'] : 0;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  addLigne() {
    this.listDocument.push({ id: 0 });
    this.listDocument = [...this.listDocument];
  }

  deleteLigne(row) {
    if (row.id) {
      this.deleteElm.push(row);
      this.deleteElm = [...this.deleteElm];
    }
    const temp = this.listDocument.filter(elt => elt !== row);
    this.listDocument = temp;
    const list = this.dataModif.filter(elt => elt !== row);
    this.dataModif = list;
  }

  editLigne(doc) {
    doc.descriptionLast = doc.description;
    doc.contentBase64Last = doc.contentBase64;
    doc.nomFichierLast = doc.nomFichier;
    doc.oTypeDocClientLast = Object.assign( {}, doc.oTypeDocClient);
    doc['clefObjetParent'] = this.detail ? this.detail['id'] : 0;
    doc.nomclass = 'FileObject';
    doc.edit = true;
    const param = {
      'servlet': 'DBGestionDocClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        this.dataModif.push(data.data)
      }
    });
  }

  saveEdit(row) {
    row.edit = false;
    row.isEdit = true;
    const  list = [];
    this.dataModif.forEach(elt => {
      if (elt.id === row.id) {
        elt = {...elt, ...row};
      }
      list.push(elt)
    });
    this.dataModif = list;
  }

  cancel(row) {
    if (!row.isEdit) {
      delete row.urlImg;
    }

    row.description = row.descriptionLast;
    row.contentBase64 = row.contentBase64Last;
    row.nomFichier = row.nomFichierLast;
    row.oTypeDocClient = Object.assign( {}, row.oTypeDocClientLast);

    delete row.descriptionLast;
    delete row.contentBase64Last;
    delete row.oTypeDocClientLast;
    delete row.nomFichierLast;

    row.edit = false;
  }

}
